import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

const style = require('./index.css');

export interface IHTML5BannerProps {
  context: IAdFoxBannerContext;
}

export class HTML5Banner extends React.Component<IHTML5BannerProps> {
  public render() {
    return (
      <div className={style['bannerWrapper']}>
        <iframe
          width="100%"
          marginWidth={0}
          marginHeight={0}
          scrolling="no"
          frameBorder="0"
          srcDoc={this.props.context.html}
        />
      </div>
    );
  }
}
